import axios from 'axios';

const API_URL = 'http://localhost:8000/api/users/';

export const createUser = async (userData) => {
    try {
        const response = await axios.post(API_URL, userData);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const fetchRecentUsers = async () => {
    try {
        const response = await axios.get(`${API_URL}recent`);
        return response.data;
    } catch (error) {
        console.error('Error fetching recent users:', error);
        throw error;
    }
};

export const fetchAllUsers = async () => {
    try {
        const response = await axios.get(`${API_URL}all`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all users:', error);
        throw error;
    }
};

// Add other user-related API functions here as needed
